module.exports = __webpack_public_path__ + "img/train-5.838bd89d.jpg";